import {AbstractProfileCollection} from './abstractProfileCollection';
import {Review} from '../model/review';

export const Reviews = AbstractProfileCollection.extend({
    _name: 'Reviews',
    model: Review,
    urlRoot: '/reviews/get.json',
});
